{
  "New customer": "לקוח חדש",
  "Existing customer": "לקוח קיים",
  "Supplier": "ספק",
  "Invoice / payment": "חשבונית / תשלום",
  "Notification": "הודעה אוטומטית",
  "Newsletter / promotion": "ניוזלטר / פרסום",
  "Spam": "ספאם",
  "Other": "אחר",
  "Alert the team": "התראה לצוות",
  "List it": "להציג ברשימה",
  "File it away": "לתייק בצד",
  "To handle": "לטיפול",
  "Filtered": "סוננו",
  "Not sorted": "לא מוין",
  "Your mailbox, sorted: customers first, suppliers and invoices listed, the rest filed away": "תיבת המייל שלכם, ממוינת: לקוחות קודם, ספקים וחשבוניות ברשימה, וכל השאר מתויק בצד",
  "Email sorting isn't switched on for this platform yet.": "מיון המיילים עדיין לא הופעל במערכת הזו.",
  "Forwarding address created": "כתובת ההעברה נוצרה",
  "Sort your email automatically": "מיון אוטומטי של המיילים",
  "Forward your business mailbox to an address of ours. Every email is sorted as it arrives: new and existing customers, suppliers, invoices, notifications, newsletters and spam. Customers alert the team and get a reply drafted for you to send; the rest waits in a list or is filed away. Nothing is deleted, and the original stays in your mailbox.": "מעבירים את תיבת המייל של העסק לכתובת שלנו, וכל מייל ממוין ברגע שהוא מגיע: לקוחות חדשים וקיימים, ספקים, חשבוניות, הודעות אוטומטיות, ניוזלטרים וספאם. על לקוחות הצוות מקבל התראה, ונכתבת להם טיוטת תשובה שאתם שולחים; כל השאר ממתין ברשימה או מתויק בצד. שום מייל לא נמחק, והמקור נשאר בתיבה שלכם.",
  "Create my forwarding address": "יצירת כתובת העברה",
  "An owner or admin can switch this on.": "בעלים או מנהל יכולים להפעיל את זה.",
  "Sorting paused": "המיון הושהה",
  "Sorting resumed": "המיון חודש",
  "Forwarding address": "כתובת העברה",
  "Receiving": "מקבל מיילים",
  "Waiting for the first email": "ממתין למייל הראשון",
  "Copy address": "העתקת הכתובת",
  "Last email: {when}": "המייל האחרון: {when}",
  "Gmail is asking you to confirm": "Gmail מבקש אישור",
  "{who} asked to forward its mail here. Open the link to allow it, then come back.": "{who} ביקש להעביר לכאן את הדואר שלו. פתחו את הקישור כדי לאשר, ואז חזרו לכאן.",
  "Your mailbox asked to forward its mail here. Open the link to allow it, then come back.": "תיבת המייל שלכם ביקשה להעביר לכאן את הדואר. פתחו את הקישור כדי לאשר, ואז חזרו לכאן.",
  "Confirm in Gmail": "אישור ב-Gmail",
  "Or type this code in Gmail's settings: {code}": "או הקלידו את הקוד הזה בהגדרות של Gmail: {code}",
  "How to forward from Gmail": "איך מעבירים מ-Gmail",
  "In Gmail on a computer, open Settings (the gear) → See all settings → Forwarding and POP/IMAP.": "ב-Gmail במחשב, פותחים את ההגדרות (גלגל השיניים) ← הצגת כל ההגדרות ← העברה ו-POP/IMAP.",
  "Choose Add a forwarding address and paste the address above. Gmail sends us a confirmation; within a minute it shows up on this page with a button.": "בוחרים \"הוספת כתובת להעברה\" ומדביקים את הכתובת שלמעלה. Gmail שולח אלינו אישור, ותוך דקה הוא מופיע בעמוד הזה עם כפתור.",
  "Press Confirm in Gmail here, then back in Gmail's settings choose Forward a copy of incoming mail and keep Gmail's copy in the Inbox. Save.": "לוחצים כאן על \"אישור ב-Gmail\", ואז בהגדרות של Gmail בוחרים \"העבר עותק של דואר נכנס\" ו\"השאר את העותק של Gmail בתיבת הדואר הנכנס\". שומרים.",
  "Gmail doesn't forward what it already put in Spam. To forward only part of your mail, use a Gmail filter with Forward it instead.": "Gmail לא מעביר מיילים שכבר סימן כספאם. כדי להעביר רק חלק מהדואר, אפשר ליצור ב-Gmail מסנן עם \"העבר אל\" במקום.",
  "Google Workspace: if forwarding is greyed out, your admin has to allow automatic forwarding for your account.": "ב-Google Workspace: אם אפשרות ההעברה אפורה, מנהל החשבון צריך לאפשר העברה אוטומטית עבורכם.",
  "Every kind": "כל הסוגים",
  "Nothing waiting": "אין מה לטפל",
  "No email here": "אין כאן מיילים",
  "Customer emails and anything else that needs a person show up here as they arrive.": "מיילים מלקוחות וכל מה שדורש טיפול של אדם יופיעו כאן ברגע שהם מגיעים.",
  "Emails appear here once your mailbox forwards to the address above.": "המיילים יופיעו כאן אחרי שהתיבה שלכם תתחיל להעביר לכתובת שלמעלה.",
  "(no subject)": "(ללא נושא)",
  "Done": "טופל",
  "Back to the list": "החזרה לרשימה",
  "{n} attachments": "{n} קבצים מצורפים",
  "by your sender rule": "לפי כלל השולח שלכם",
  "automatically, from the email's headers": "אוטומטית, לפי כותרות המייל",
  "by AI": "על ידי AI",
  "by your team": "על ידי הצוות",
  "This sender is already one of your contacts.": "השולח כבר מופיע באנשי הקשר שלכם.",
  "This email was too large to read here; open it in your mailbox.": "המייל גדול מכדי להציג אותו כאן. פתחו אותו בתיבת המייל.",
  "The text of this email is no longer kept; open it in your mailbox.": "תוכן המייל כבר לא נשמר כאן. פתחו אותו בתיבת המייל.",
  "Open in Gmail": "פתיחה ב-Gmail",
  "This email is": "המייל הזה הוא",
  "Next time": "בפעם הבאה",
  "Let the sorter decide": "שהמיון יחליט",
  "Always sort {address} this way": "תמיד למיין את {address} כך",
  "Always sort everyone at {domain} this way": "תמיד למיין כך את כל השולחים מ-{domain}",
  "What happens to each kind": "מה קורה עם כל סוג",
  "Alert the team: listed under To handle, and the team is told the way handoffs reach them. List it: listed under To handle. File it away: kept under Filtered, nobody is told.": "התראה לצוות: מופיע תחת \"לטיפול\", והצוות מקבל הודעה כמו בהעברה לנציג. להציג ברשימה: מופיע תחת \"לטיפול\". לתייק בצד: נשמר תחת \"סוננו\", בלי להודיע לאף אחד.",
  "Rule removed": "הכלל הוסר",
  "Sender rules": "כללי שולחים",
  "A rule wins over the AI every time. Add one from any email: open it, choose what it is and how to sort that sender next time.": "כלל תמיד גובר על ה-AI. מוסיפים כלל מכל מייל: פותחים אותו, בוחרים מה הוא ואיך למיין את השולח בפעם הבאה.",
  "No rules yet.": "עדיין אין כללים.",
  "Urgent": "דחוף",
  "Remind the team when a customer waits": "תזכורת לצוות כשלקוח ממתין",
  "One reminder per email, outside quiet hours, until it is marked Done. Urgent emails alert the team right away, unless their kind is filed away.": "תזכורת אחת לכל מייל, מחוץ לשעות השקט, עד שמסמנים \"טופל\". מיילים דחופים מתריעים לצוות מיד, אלא אם הסוג שלהם מתויק בצד.",
  "Never": "אף פעם",
  "After {n} hours": "אחרי {n} שעות",
  "Show more": "הצגת עוד",
  "Sort again": "מיון מחדש",
  "Sorted": "מוין",
  "Off": "כבוי",
  "Draft": "טיוטה",
  "Automatic": "אוטומטי",
  "Nothing is written. Customers' emails wait for you under To handle.": "לא נכתבת תשובה. מיילים של לקוחות ממתינים לכם תחת \"לטיפול\".",
  "The AI writes a reply to each customer's email from your agent's knowledge. You read it, change anything, and press Send.": "ה-AI כותב תשובה לכל מייל של לקוח, מתוך הידע של הסוכן שלכם. אתם קוראים, משנים מה שצריך ולוחצים \"שליחה\".",
  "Replies go out by themselves when the email is plainly a customer's, the sender is a customer on file or their email provider verified them, and nothing about it needs a person. Complaints, urgent emails and anything the AI isn't sure about stay as drafts for you.": "התשובות יוצאות לבד כשברור שהמייל מלקוח, השולח הוא לקוח קיים או שספק המייל שלו אימת אותו, ואין בו שום דבר שדורש אדם. תלונות, מיילים דחופים וכל מה שה-AI לא בטוח בו נשארים כטיוטה בשבילכם.",
  "Answered by AI": "נענה על ידי AI",
  "Replied": "נענה",
  "Reply ready": "תשובה מוכנה",
  "Reply not sent": "התשובה לא נשלחה",
  "Replies to customers": "תשובות ללקוחות",
  "Replies are sent under your business name, and when customers answer, it reaches {address}.": "התשובות נשלחות בשם העסק שלכם, וכשלקוחות עונים, התשובה מגיעה אל {address}.",
  "Add a customer contact email under Settings → Business so customers' answers reach you.": "הוסיפו מייל ליצירת קשר עם לקוחות בהגדרות ← עסק, כדי שתשובות הלקוחות יגיעו אליכם.",
  "Reply written": "התשובה נכתבה",
  "Reply sent": "התשובה נשלחה",
  "Reply discarded": "התשובה נמחקה",
  "Writing…": "כותב…",
  "Write a reply with AI": "כתיבת תשובה עם AI",
  "Reply": "תשובה",
  "Check this one before sending": "כדאי לבדוק לפני השליחה",
  "Not sent: {reason}": "לא נשלח: {reason}",
  "To": "אל",
  "Subject": "נושא",
  "Send reply": "שליחת התשובה",
  "Discard": "מחיקה"
}
